var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{on:{"click":_vm.destroyDialog}},[_c('div',{staticClass:"button"},[_vm._v(_vm._s(_vm.$t('btn.destroy')))])])}
var staticRenderFns = []

export { render, staticRenderFns }